import api from "../../../api";

export function rewardInfo() {
  return api.get("cms/rewards/info");
}

export function rewardUserList(page) {
  return api.get(`cms/rewards/user-list?pageSize=10&pageNumber=${page}`);
}

export function coinHistory(userId) {
  return api.get(`cms/rewards/analysis/coin-history/${userId}`);
}
